var React = require('react');

function Link (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M22 7.368a5.336 5.336 0 0 1-1.572 3.8l-1.544 1.544a1 1 0 0 1-1.414-1.414l1.544-1.544a3.369 3.369 0 0 0 0-4.763 3.451 3.451 0 0 0-4.763 0L12.707 6.53a1 1 0 1 1-1.414-1.414l1.544-1.544A5.368 5.368 0 0 1 22 7.368ZM3.572 20.428a5.368 5.368 0 0 0 7.591 0l1.544-1.544a1 1 0 0 0-1.414-1.414l-1.544 1.544a3.451 3.451 0 0 1-4.763 0 3.369 3.369 0 0 1 0-4.763l1.544-1.544a1 1 0 1 0-1.414-1.414l-1.544 1.544a5.368 5.368 0 0 0 0 7.591Zm5.34-4.34a.993.993 0 0 0 .707-.293L15.8 9.619a1 1 0 1 0-1.414-1.414l-6.181 6.176a1 1 0 0 0 .707 1.707Z"}));
}

Link.defaultProps = {"fill":"#000","width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = Link;

Link.default = Link;
